import script from "./ContractTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractTable.vue?vue&type=script&setup=true&lang=js"

import "./ContractTable.vue?vue&type=style&index=0&id=2504c729&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2504c729"]])

export default __exports__